export const stockNames = [
	"AAPL",
	"MSFT",
	"GOOGL",
	"AMZN",
	"TSLA",
	"FB",
	"BRK.B",
	"V",
	"JNJ",
	"WMT",
	"JPM",
	"NVDA",
	"PG",
	"UNH",
	"DIS",
	"PYPL",
	"MA",
	"NFLX",
	"INTC",
	"KO",
	"NKLA",
	"IBIO",
	"VERB",
	"GMDA",
	"SOXS",
	"CCL",
	"SQQQ",
	"CISS",
	"NIO",
	"GOGN",
	"AGORF",
	"CYBN",
	"NVACF",
	"CHG",
	"PLUGD",
	"DFSPX",
	"AISP",
	"SCRM",
	"SYIEF",
	"AMST",
	"HUNGF",
	"VRSN",
	"MDDCF",
	"MEC",
	"CEOS",
	"FNINF",
	"SPSAF",
	"PRO",
	"UMAM",
	"GLQ",
	"PPZRF",
	"FCNE",
	"AHNR",
	"SRTS",
	"CDNTF",
	"AFOVF",
	"GRX",
	"TBRIF",
	"PTLKF",
	"MARUY",
	"BROXF",
	"DTNOY",
	"TNTTF",
	"ORIA",
	"CJPRF",
	"WSR",
	"BWCXP",
	"APQT",
	"ATHOF",
	"FHNGY",
	"VLD",
	"ZEV-WT",
	"FVVSF",
	"FOGRX",
	"RVLV",
	"TLSI",
	"TOPCF",
	"MIGI",
	"ACEYY",
	"SYX",
	"TRVN",
	"CBSZF",
	"RRETY",
	"STJPF",
	"CHI",
	"ASST",
	"CESTY",
	"ENBRF",
	"CGEM",
	"NM",
	"QBEIF",
	"FRVWY",
	"SPG",
	"KYN",
	"MLYBY",
	"AUUMF",
	"CSYJY",
	"OGGNF",
	"MDVLQ",
	"AFALX",
	"LGACW",
	"NTRSP",
	"STRC",
	"WEXPF",
	"AEF",
	"FULO",
	"CII",
	"GRPTF",
	"IVDN",
	"CBKCQ",
	"VPRB",
	"SNNVF",
	"GCAAF",
	"ACBA",
	"MODG",
	"IMBBF",
	"PSA-PN",
	"HKHHY",
	"PXSAW",
	"IGPFF",
	"GAMB",
	"MXL",
	"ASPP",
	"RMYHY",
	"CRWS",
	"MERFX",
	"PERI",
	"ASTTF",
	"KAYS",
	"CYLC",
	"AIU",
	"CHWY",
	"PACE-UN",
	"REGMF",
	"AFCL",
	"CTU",
	"ASB-PD",
	"CECBF",
	"BAC-PN",
	"SLTFF",
	"GELYF",
	"MDEX",
	"AGI",
	"UNIT",
	"IPHYF",
	"CVEO",
	"TLTFF",
	"PGRE",
	"JLGAX",
	"TYCMY",
	"CFCGF",
	"FIX",
	"BZFDW",
	"DETRF",
	"ELEC",
	"AWIN",
	"TYTMF",
	"PHXM",
	"LTMCF",
	"XYIGF",
	"CFRLF",
	"NSHBY",
	"GHY",
	"LWCL",
	"SEPGF",
	"EXPCU",
	"PONGF",
	"GMCR",
	"NMM",
	"DRVN",
	"MRTMF",
	"LOGN",
	"EVFM",
	"BZLYF",
	"NDP",
	"LMSQF",
	"EIX",
	"MLHR",
	"ABEOW",
	"IONI",
	"IIIV",
	"ENZ",
	"CHKMF",
	"RRSFF",
	"SDS",
	"ALKN",
	"CCGPY",
	"CEA",
	"TREAY",
	"KGGNF",
	"ARIA",
	"LUNG",
	"ANGO",
	"VTWRF",
	"HNST",
	"SOMNF",
	"EMKR",
	"SFRWW",
	"ALPC",
	"HCXLY",
	"PDYN",
	"LFSYY",
	"SURVF",
	"CPTK",
	"AGRPY",
	"LFAC",
	"FUWAF",
	"PNXPF",
	"PFRRF",
	"ISRLU",
	"EDMCQ",
	"NTIC",
	"BELFB",
	"AEMMY",
	"TJX",
	"TETC",
	"TWNK",
	"WATT",
	"CMGHY",
	"EXPE",
	"NXTFF",
	"SHGKY",
	"YALA",
	"TOIPF",
	"WE",
	"CBYI",
	"IBTN",
	"YRAIF",
	"GODN",
	"KCGI-WT",
	"FPNUF",
	"FDHC",
	"LRE",
	"IFIN-UN",
	"DELCF",
	"CBCYB",
	"FWONK",
	"BADEF",
	"MODN",
	"RLYGF",
	"TMPMW",
	"WNRS",
	"GECCN",
	"IMAHF",
	"EL",
	"EICB",
	"KMT",
	"PGR",
	"IGNYU",
	"AINC",
	"FDLPF",
	"PEFDF",
	"EGL",
	"SSHLY",
	"KURRF",
	"LTCP",
	"SCTBF",
	"CHLWF",
	"UCBJY",
	"CIWT",
	"CCGDF",
	"ATAKR",
	"F-PD",
	"GEODF",
];
